"use client";

import { useEffect, useState } from "react";
import { carevincoBrand } from "@/shared/config/brand";

export function useAppShellReady() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let fallbackTimer: number | undefined;

    async function prepareShell() {
      const criticalAssets = [
        carevincoBrand.logo,
        "/assets/landingHeader/portal-icon-e066ad3f-9b90-4373-be93-cecb5fa71eec.png",
      ];
      const assetReadiness = Promise.all(
        criticalAssets.map(
          (source) =>
            new Promise<void>((resolve) => {
              const image = new window.Image();
              image.onload = () => resolve();
              image.onerror = () => resolve();
              image.src = source;
              if (image.complete) resolve();
            }),
        ),
      );
      const fontReadiness = "fonts" in document ? document.fonts.ready : Promise.resolve();

      await Promise.race([
        Promise.all([fontReadiness, assetReadiness]),
        new Promise<void>((resolve) => {
          fallbackTimer = window.setTimeout(resolve, 1_500);
        }),
      ]).catch(() => undefined);
      if (fallbackTimer != null) {
        window.clearTimeout(fallbackTimer);
        fallbackTimer = undefined;
      }
      await new Promise<void>((resolve) => {
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => resolve()));
      });

      if (!cancelled) setIsReady(true);
    }

    void prepareShell();
    return () => {
      cancelled = true;
      if (fallbackTimer != null) window.clearTimeout(fallbackTimer);
    };
  }, []);

  return isReady;
}
